<style src="./EditEvent.scss" lang="scss" scoped></style>
<template>
  <section class="edit-event">
    <panel-tab @change-panel="changePanelTab">
      <panel-tab-item tab-id="INSERIR" :panel-choose="panelTab.panelTabChoose">
        Editar dados
      </panel-tab-item>
      <panel-tab-item tab-id="UPLOAD" :panel-choose="panelTab.panelTabChoose" :enabled="hasEventId">
        Atualizar Listagem
      </panel-tab-item>
    </panel-tab>

    <transition name="transition-tab-item">
      <form-data-input
        v-if="panelTab.panelTabChoose === 'INSERIR'"
        :edit-data="eventData"
        @refresh-list="refreshList"
        @close="closePanel" />
    </transition>

    <transition name="transition-tab-item">
      <form-file-input
        :event-id="eventId"
        v-if="panelTab.panelTabChoose === 'UPLOAD'"
        @close="closePanel"
        @refresh-list="refreshList" />
    </transition>
  </section>
</template>

<script>
import { PanelTab, PanelTabItem } from '@/components/primitives'
import FormDataInput from './form-data-input/FormDataInput'
import FormFileInput from './form-file-input/FormFileInput'

export default {
  name: 'EditEvent',
  components: {
    PanelTab,
    PanelTabItem,
    FormDataInput,
    FormFileInput
  },
  props: {
    editData: {
      default: null
    }
  },
  data () {
    return {
      eventData: null,
      eventId: false,
      panelTab: {
        panelTabChoose: 'INSERIR'
      }
    }
  },
  computed: {
    hasEventId () {
      return false
    }
  },
  mounted () {
    this.eventData = {...this.editData}
    this.eventId = this.editData._id
  },
  methods: {
    closePanel () {
      this.$parent.$emit('close', false)
    },
    changePanelTab (pPanelItemId) {
      this.panelTab.panelTabChoose = pPanelItemId
    },
    refreshList () {
      this.panelTab.panelTabChoose = 'INSERIR'
      this.$emit('refresh-list')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/event/components/edit-event/EditEvent.vue